import './vendor/bootstrap';
import './vendor/mixitup';
import './vendor/parallax.min';
import './vendor/stellar';
import './vendor/typeit.min';

import './custom/custom';
